export const ERC20ABI = [
    "function balanceOf(address) view returns (uint)",
    "function transferFrom(address sender, address recipient, uint256 amount) external returns (bool)",
    "function approve(address owner, uint256 amount) external returns (bool)",
    "function allowance(address owner, address spender) view returns (uint)",
  ];